import { useParams } from 'react-router-dom'

import { Box, NotFound } from '@factorialco/deprecated-design-system'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import ExpensesList from 'modules/expenses/components/expenses/List'
import { GroupHeader } from 'modules/expenses/components/groups/GroupHeader'
import { useGroupDetail } from 'modules/expenses/hooks/useGroupDetail'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import policyPeriods from 'modules/payroll_bundle/store/collections/policyPeriods'

import { useExpenses } from '../../ExpensesContext'
import { usePageActions } from './usePageActions'

const GroupDetailPage = () => {
  const { groupId } = useParams()
  const { navigation } = useNavigation()
  const { data } = useExpenses()

  const { value: currentPayrollPeriod } = useAsyncData(() => policyPeriods.isCurrentOpen(), [])

  const { group, loading: loadingGroup } = useGroupDetail({ id: Number(groupId) })
  const { actions, Modals } = usePageActions({
    group,
    currentPayrollPeriodOpen: Boolean(currentPayrollPeriod?.open_to_supplements),
    canSetToPaid: data.expenses._policies.expenseSetToPaid.can,
    canRestartApprovalFlow: data.expenses._policies.expenseRestartApprovalFlow.can,
    canOverrideApprovalFlow: data.expenses._policies.expenseOverrideApprovalFlow.can,
  })

  return (
    <>
      {group && <GroupHeader group={group} actions={actions} />}
      <ResponsivePage.Body error={false} loading={loadingGroup} variant="full" showHeader={false}>
        <Modals />
        {group ? (
          <Box gap="s16">
            <ExpensesList
              group={group}
              back={{ href: navigation.expenses.groups.id.fullPath({ groupId: group.id }) }}
            />
          </Box>
        ) : (
          <NotFound
            title={i18n.t('errors.page_not_found.title')}
            description={i18n.t('errors.page_not_found.description')}
          />
        )}
      </ResponsivePage.Body>
    </>
  )
}

export default GroupDetailPage
